import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

const dispatchTransitionComplete = () => {
    document.dispatchEvent(new CustomEvent('pageTransitionComplete'));
};

export function initPageTransition() {
    const wrapper = document.querySelector('.page-reveal-transition');
    if (!wrapper) {
        dispatchTransitionComplete();
        return;
    }


    wrapper.classList.remove('d-none');

    const gateLeft = wrapper.querySelector('.gate-left');
    const gateRight = wrapper.querySelector('.gate-right');

    const columns = wrapper.querySelectorAll('.curtain-column');
    const background = wrapper.querySelector('.page-reveal-background');
    const contentArea = wrapper.querySelector('.content-area');
    const heading = contentArea?.querySelector('h5');
    const loaderProgress = contentArea?.querySelector('.loader-progress');
    const loaderLine = contentArea?.querySelector('.loader-line');
    const loaderPercentage = contentArea?.querySelector('.loader-percentage');

    if (!columns.length) {
        wrapper.classList.add('transition-done');
        gsap.set(wrapper, { display: 'none' });
        dispatchTransitionComplete();
        document.body.style.overflow = '';
        return;
    }

    // Compensate for scrollbar width to prevent layout shift
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const header = document.querySelector('.main-header');
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = scrollbarWidth + 'px';
    if (header) header.style.paddingRight = scrollbarWidth + 'px';

    let split;
    if (heading) {
        heading.style.opacity = 1;
        split = new SplitText(heading, {
            type: 'chars',
            mask: 'chars'
        });
        gsap.set(split.chars, { yPercent: 110 });
    }

    const tl = gsap.timeline({
        onComplete: () => {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
            if (header) header.style.paddingRight = '';
            wrapper.classList.add('transition-done');
            if (split) split.revert();
            gsap.set(wrapper, { display: 'none' });
            dispatchTransitionComplete();
        }
    });

    if (split) {
        tl.to(split.chars, {
            yPercent: 0,
            duration: 0.3,
            stagger: 0.03,
            ease: 'power3.out'
        }, '-=0.1');
    }

    tl.to([loaderProgress, loaderPercentage], {
        opacity: 1,
        duration: 0.4,
        ease: 'power2.out'
    }, '-=0.2')

        .to(loaderLine, {
            scaleX: 1,
            duration: 1.6,
            ease: 'power2.inOut',
            onUpdate: function () {
                if (loaderPercentage) {
                    const progress = Math.round(this.progress() * 100);
                    loaderPercentage.textContent = progress + '%';
                }
            }
        }, '-=0.1');

    const hasGateAnimation = gateLeft && gateRight;
    if (hasGateAnimation) {
        const gateDuration = 1.8;
        gsap.set([gateLeft, gateRight], {
            transformPerspective: 1400,
            transformStyle: 'preserve-3d',
            willChange: 'transform'
        });
        tl.addLabel('doorsOpen');
        tl.to(gateLeft, {
            rotationY: -130,
            duration: gateDuration,
            ease: 'power3.inOut',
            transformOrigin: 'left center'
        }, 'doorsOpen');
        tl.to(gateRight, {
            rotationY: 130,
            duration: gateDuration,
            ease: 'power3.inOut',
            transformOrigin: 'right center'
        }, 'doorsOpen');
        tl.to(contentArea, {
            opacity: 0,
            yPercent: -50,
            duration: 0.7,
            ease: 'power2.in'
        }, `doorsOpen+=${gateDuration * 0.5}`);
    } else {
        tl.to(contentArea, {
            opacity: 0,
            yPercent: -50,
            duration: 0.7,
            ease: 'power2.in'
        }, '-=0.2');
    }

    const visibleColumns = [...columns].filter(col => col.offsetParent !== null || getComputedStyle(col).display !== 'none');
    const count = visibleColumns.length;
    const center = Math.floor(count / 2);

    const groups = [[visibleColumns[center]]];
    for (let i = 1; i <= center; i++) {
        const pair = [];
        if (center - i >= 0) pair.push(visibleColumns[center - i]);
        if (center + i < count) pair.push(visibleColumns[center + i]);
        if (pair.length) groups.push(pair);
    }

    groups.forEach((group, i) => {
        tl.to(group, {
            scaleY: 0,
            transformOrigin: 'top center',
            duration: 0.5,
            ease: 'power3.in',
        }, i === 0 ? '-=0.4' : '-=0.35');
    });

    tl.to(background, {
        y: '-100%',
        duration: 0.5,
    }, '-=0.2');
}
